export const addRandomKey = (array) => {
    return array.map((item) => {
        return {
            randomKey: Math.ceil(Math.random() * 100000000),
            ...item,
        };
    });
};

/**
 * Safely parses a JSON string value
 * @param {string | null | undefined} value - The JSON string to parse
 * @param {any} fallback - Optional fallback value if parsing fails (defaults to null)
 * @returns {any} Parsed JSON value or fallback
 */
export const safeJsonParse = (value, fallback = null) => {
    if (!value) return fallback;

    try {
        return JSON.parse(value);
    } catch (error) {
        console.error('Failed to parse JSON:', error);
        return fallback;
    }
};
